import { t } from "i18next";
import { parsePhoneNumber } from "react-phone-number-input";

export const filterCharacters = {
    pattern: /[^\p{L}\p{N}\s\-()]/gu,
    replacement: ''
};

export const cleanInput = (value) => {
    const filtered = value?.replace(filterCharacters.pattern, filterCharacters.replacement);
    return filtered;
};

export const filterCharactersHandle = {
    pattern: /[^\p{L}\p{N}\s\-(),'’‘".]/gu,
    replacement: ''
};

export const cleanInputHandle = (value) => {
    const filtered = value.replace(filterCharactersHandle.pattern, filterCharactersHandle.replacement);
    return filtered;
};

export const filterDescriptionCharsDot = {
    pattern: /[^\p{L}\p{N}\s\-().,'’‘"]/gu,
    replacement: ""
};

export const cleanDescriptionDotInputs = (value) => {
    const filtered = value.replace(filterDescriptionCharsDot.pattern, filterDescriptionCharsDot.replacement);
    return filtered;
};

export function removeTrailingSpacesAndDashes(value) {
    return typeof value === "string" ? value.replace(/[\s-]+$/g, "") : value;
}

export const trimInput = (value) => value?.trim();

export const createHandleChange = (setFormData, setFieldErrors, t) => {
    return (field) => ({ target }) => {
        const rawValue = target.value;
        const cleanedValue = cleanInput(rawValue);

        setFormData((prev) => ({ ...prev, [field]: cleanedValue }));

        const hasInvalidChars = filterCharacters.pattern.test(rawValue);
        if (hasInvalidChars) {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: t('common.allowed_characters'),
            }));
        } else {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: '',
            }));
        }
    };
};

export const createHandleChangeApostrophe = (setFormData, setFieldErrors, t) => {
    return (field) => ({ target }) => {
        const rawValue = target.value;
        const cleanedValue = cleanInputHandle(rawValue);

        setFormData((prev) => ({ ...prev, [field]: cleanedValue }));

        const hasInvalidChars = filterCharactersHandle.pattern.test(rawValue);
        if (hasInvalidChars) {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: t('common.allow_characters'),
            }));
        } else {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: '',
            }));
        }
    };
};

export const descriptionHandleChange = (setFormData, setFieldErrors, t) => {
    return (field) => ({ target }) => {
        const rawValue = target.value;
        const cleanedValue = cleanInputHandle(rawValue);

        setFormData((prev) => ({ ...prev, [field]: cleanedValue }));

        const hasInvalidChars = filterCharactersHandle.pattern.test(rawValue);
        if (hasInvalidChars) {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: t('products.description_characters'),
            }));
        } else {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: '',
            }));
        }
    };
};
export const descriptionDotHandleChange = (setFormData, setFieldErrors, t) => {
    return (field) => ({ target }) => {
        const rawValue = target.value;

        let cleanedValue;

        cleanedValue = cleanDescriptionDotInputs(rawValue);

        setFormData((prev) => ({ ...prev, [field]: cleanedValue }));

        const hasInvalidChars = filterDescriptionCharsDot.pattern.test(rawValue);
        if (hasInvalidChars) {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: t('products.description_characters'),
            }));
        } else {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: '',
            }));
        }
    };
};

export const createGraceRemindervalidation = (setFormData, setFieldErrors, t) => {
    return (field) => ({ target }) => {
        const rawValue = target.value;

        if (rawValue === "") {
            setFormData((prev) => ({ ...prev, [field]: "" }));
            setFieldErrors((prev) => ({ ...prev, [field]: "" }));
            return;
        }
        const digitsOnly = rawValue.replace(/\D/g, '');
        if (digitsOnly === "") {
            return;
        }
        const num = Number(digitsOnly);
        const allowEntry = num >= 1 && num <= 7;

        if (!allowEntry) {
            setFieldErrors((prev) => ({
                ...prev,
                [field]: t('products.days_message'),
            }));
            setFormData((prev) => ({ ...prev, [field]: prev[field] }));
            return;
        }
        setFormData((prev) => ({ ...prev, [field]: digitsOnly }));
        setFieldErrors((prev) => ({ ...prev, [field]: '' }));
    };
};

export const createCustomHandleChange = (formik, setErrors, t) => {
    return (e) => {
        const { name, value } = e.target;

        const cleanedValue = cleanInput(value);

        formik.setFieldValue(name, cleanedValue);

        if (value !== cleanedValue) {
            setErrors((prev) => ({
                ...prev,
                [name]: t("common.allowed_characters"),
            }));
        } else {
            setErrors((prev) => {
                const { [name]: _, ...rest } = prev;
                return rest;
            });
        }
    };
}
export const createCustomHandleApostropheChange = (formik, setErrors, t) => {
    return (e) => {
        const { name, value } = e.target;

        const cleanedValue = cleanInputHandle(value);

        formik.setFieldValue(name, cleanedValue);

        if (value !== cleanedValue) {
            setErrors((prev) => ({
                ...prev,
                [name]: t("common.allow_characters"),
            }));
        } else {
            setErrors((prev) => {
                const { [name]: _, ...rest } = prev;
                return rest;
            });
        }
    };
}

export const createCustomHandleChangeApostrophe = (formik, setErrors, t) => {
    return (e) => {
        const { name = "", value = "" } = e?.target || {};

        const cleanedValue = cleanInputHandle(value);

        formik?.setFieldValue(name, cleanedValue);


        if (value !== cleanedValue) {
            setErrors((prev) => ({
                ...prev,
                [name]: t("common.allow_characters"),
            }));
        } else {
            setErrors((prev) => {
                const { [name]: _, ...rest } = prev;
                return rest;
            });
        }
    };
}

export const createDescriptionHandleChange = (formik, setErrors, t) => {
    return (e) => {
        const { name, value } = e.target;

        const cleanedValue = cleanInputHandle(value);

        formik.setFieldValue(name, cleanedValue);

        if (value !== cleanedValue) {
            setErrors((prev) => ({
                ...prev,
                [name]: t("products.description_characters"),
            }));
        } else {
            setErrors((prev) => {
                const { [name]: _, ...rest } = prev;
                return rest;
            });
        }
    };
}

export const createDescriptionDotsHandleChange = (formik, setErrors, t) => {
    return (e) => {
        const { name, value } = e.target;

        const cleanedValue = cleanDescriptionDotInputs(value);

        formik.setFieldValue(name, cleanedValue);

        if (value !== cleanedValue) {
            setErrors((prev) => ({
                ...prev,
                [name]: t("products.description_characters"),
            }));
        } else {
            setErrors((prev) => {
                const { [name]: _, ...rest } = prev;
                return rest;
            });
        }
    };
}

export const validateAndClean = (value) => {
    const str = String(value ?? "");

    const cleaned = str.replace(/[^\p{L}\p{N}\s\-(),'’‘"]/gu, '');
    const isValid = /^[\p{L}\p{N}\s\-(),'’‘"]*$/u.test(str);

    return { cleaned, isValid };
};

export const createTagHandleChange = (setFormData, setFieldErrors, t) => {
    return (field) => ({ target }) => {
        const rawValue = target?.value ?? "";
        const { cleaned, isValid } = validateAndClean(rawValue);

        setFormData(prev => ({ ...prev, [field]: cleaned }));
        setFieldErrors(prev => ({
            ...prev,
            [field]: isValid ? '' : t("common.allow_characters")
        }));
    };
};


export const removePlusFromNum = (number) => {
    if (number?.startsWith("+")) {
        const phoneNumber = parsePhoneNumber(String(number));
        return phoneNumber?.formatNational().replace(/\s+/g, "");
    } else return number;
}

export const formatBillingPeriodText = (text) => {
    switch (text) {
        case "BIWEEKLY":
            return <>{t("products.period_EVERY_2_WEEKS")} </>
        case "DAILY_WITH_WEEKENDS":
            return <>{t("products.period_DAILY_WITH_WEEKENDS")} </>
        case "DAILY_WITH_SATURDAYS":
            return <>{t("products.period_DAILY_WITH_SATURDAYS")} </>
        case "HALFYEARLY":
            return <>{t("products.period_HALFYEARLY")} </>
        default:
            return text?.charAt(0).toUpperCase() + text?.slice(1).toLocaleLowerCase();
    }
}

export const formatTextUppercase = (text) => {
    return text
        ?.toUpperCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export const policyDisplay = (data) => {
    switch (data?.policy) {
        case "FIXED":
            return <><p className="policy m-0">{t("products.fixed_billing").toUpperCase()}</p></>
        case "CUSTOM":
            return <><p className="policy m-0">{t("products.custom_billing").toUpperCase()}</p></>
        case "TARGET":
            if (data.targetEqualParts && !data.recoverMissed) {
                return <div className="flex gap-1">
                    <p className="policy m-0">{t("billing", { val: data.policy })}</p>
                    <p className="policy target-stat m-0">{t("product.equal")}</p>
                </div>
            } else if (data.targetEqualParts && data.recoverMissed) {
                return <div className="flex gap-1">
                    <p className="policy m-0">{t("billing", { val: data.policy })}</p>
                    <p className="policy target-stat m-0">{t("product.equal")}</p>
                    <p className="policy target-stat-miss m-0">{t("product.recovery")}</p>
                </div>
            } else {
                return <div className="flex gap-1">
                    <p className="policy m-0">{t("billing", { val: data.policy })}</p>
                    <p className="policy target-stat m-0">{t("product.varying")}</p>
                </div>
            }
        default:
            return <><p className="policy m-0">{t("billing", { val: data?.policy })}</p></>

    }
}

export const amountDisplayPerPolicy = (currency, data) => {
    let text;
    switch (data?.policy) {
        case "FIXED":
            text = `${currency} ${data.cost?.toFixed(2)}`
            break;
        case "FLEXIBLE":
            text = t("invitation.flexible_amount")
            break;
        case "CUSTOM":
            text = t("invitation.fixed_amount")
            break;
        case "TARGET":
            text = t("invitation.target_amount")
            break;
        default:
            text = t("invitation.generated_amount")
            break;
    }
    return text;
}